import { useState } from "react";
import { useDesktop } from "../../hooks";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MdArrowDropDown } from "react-icons/md";
import { toggle } from "../../services/navigationSlice";
import styled from "styled-components";
import logo from "../../assets/Vidom.png";
import search from "../../assets/search.png";
import settings from "../../assets/filter.svg";
import "../../styles/header.css";
import { logout, selectUser } from "../../services/userSlice";
import { auth } from "../../firebaseSetup";

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 2em 2em 1em 2em;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);

  @media (min-width: 801px) {
    padding: 2em 2em 2em 4em;
  }
`;

const Header = (): JSX.Element => {
  const dispatch = useDispatch();
  let activeClassName = "header-desktop-link";

  // use selector to be used to check if user is logged in
  const [dropdown, setDropdown] = useState(false);
  const { pathname } = useLocation();
  const user = useSelector(selectUser);
  let name: string = user?.displayName;

  const logoutOfApp = () => {
    // dispatch to the store with the logout action
    dispatch(logout());
    // sign out function from firebase
    auth.signOut();
  };

  return (
    <>
      <header>
        <StyledDiv>
          <div className="nav-search-cont">
            <Link to="/">
              <img
                src={logo}
                alt="Vidom-logo"
                className="vidom-logo"
              />
            </Link>
            {useDesktop() >= 1204 && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <select defaultValue="All Categories">
                  <option value="All Categories">All Categories</option>
                  <option value="IT">IT</option>
                  <option value="UI design">UI design</option>
                </select>
                <div>
                  <input
                    type="text"
                    placeholder="search for a course"
                  />
                  <span>Search</span>
                </div>
              </form>
            )}
          </div>
          {useDesktop() >= 1204 && (
            <nav className="desktop-nav">
              <ul>
                <li>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? activeClassName : undefined
                    }
                    to="/courses"
                  >
                    Courses
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? activeClassName : undefined
                    }
                    to="/plans"
                  >
                    Plans
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? activeClassName : undefined
                    }
                    to="/contact"
                  >
                    Contact Us
                  </NavLink>
                </li>

                {!user?.emailVerified && (
                  <>
                    {" "}
                    <li>
                      <Link to="/login">Login</Link>
                    </li>
                    <li>
                      <Link to="/signup">Signup</Link>
                    </li>
                  </>
                )}

                {/* to be rendered on user login */}

                {user?.emailVerified && (
                  <li
                    className="user-initials"
                    onClick={() => {
                      setDropdown(!dropdown);
                    }}
                  >
                    <span>{name.charAt(0)}</span>
                    <MdArrowDropDown
                      style={{
                        color: "var(--vidomCustomBlue)",
                        fontSize: "2em",
                        verticalAlign: "middle",
                      }}
                    />

                    <div
                      className="user-hidden-det"
                      style={{ display: dropdown ? "block" : "none" }}
                    >
                      <p>
                        <Link to="/dashboard">Dashboard</Link>
                      </p>
                      <p>
                        <Link to="/dashboard/my-account">My Account</Link>
                      </p>
                      <p onClick={logoutOfApp}>
                        <a>Logout</a>
                      </p>
                    </div>
                  </li>
                )}
              </ul>
            </nav>
          )}

          {useDesktop() < 1204 && (
            <div
              className="hamburger"
              style={{ cursor: "pointer" }}
              onClick={() => dispatch(toggle())}
            >
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
        </StyledDiv>
        {useDesktop() < 1024 && (
          <div
            className="filter-showcase"
            style={{
              display: pathname === "/dashboard/videoplayer" ? "none" : "flex",
            }}
          >
            <div className="filter-container">
              <input
                type="text"
                placeholder="Search for a course"
              />
              <div>
                <img
                  src={search}
                  alt="search"
                  className="searchicon"
                />
              </div>
            </div>
            <img
              src={settings}
              className="settings"
              alt="filter-icon"
            />
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
